<script>
import { computed, inject, watchEffect, getCurrentInstance } from "vue";

export default {
  name: "Tab",
  setup() {
    const instance = getCurrentInstance();
    const { tabs, selectTab, active } = inject("tabsState", {
      tabs: [],
      selectTab: () => {},
    });
    const index = computed(() =>
      tabs.value.findIndex((target) => target.uid === instance.uid)
    );
    const isActive = computed(() => index.value === active.value);

    const activeteTab = () => {
      selectTab(index.value);
    };

    watchEffect(() => {
      if (index.value === -1) {
        tabs.value.push(instance);
      }
    });

    return {
      activeteTab,
      isActive,
    };
  },
};
</script>
<style scoped>
.box-content {
  box-sizing: content-box;
}
.at{
    background-color: var(--color);
    color: white;
}

.border-b-2 {
  border-bottom-width: 2px;
}
.border-green-500 {
  border-bottom: 2px solid var(--color) !important;
}

.text-align {
  text-align: center;
}
.w-25 {
  width: 25%;
}
.w-50 {
  width: 50%;
}
.w-33{
  width: 33.33%;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.rounded-tl-md {
  border-top-left-radius: 0.375rem;
}
.rounded-tr-md {
  border-top-right-radius: 0.375rem;
}
.overflow-hidden {
  overflow: hidden;
}
</style>

<template>
  <div
    :class="isActive ? 'at box-content' : 'border-white'"
    class="text-align w-33 py-3 rounded-tl-md rounded-tr-md overflow-hidden cursor-pointer border-green-500"
    @click="activeteTab"
  >
    <slot />
  </div>
</template>
